import(/* webpackMode: "eager" */ "/vercel/path0/src/component/chat/ChatMainSection.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/modal/VideoCallModal.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/modal/VoiceCallModal.tsx")